// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Input, Typography } from 'antd';
// eslint-disable-next-line import/no-extraneous-dependencies
import { PlusOutlined } from '@ant-design/icons';
// CUSTOM
import { UserAccessContext } from 'context/userAccess';
import TablePager from 'shared_components/table_pager';
import { showMessage } from 'services/settings/message';
import PageTitle from 'shared_components/page_title';
import fetchSpecimens from 'services/settings/specimen';
import { fetchExamRequests, updateExamRequestSort } from 'services/shared/examRequest';
import { fetchJrReports } from 'services/settings/jrReports';
import fetchExamList from 'services/settings/examItem';
import fetchSection from 'services/shared/section';
import ExamTable from './search_table';
import DownloadCSV from 'shared_components/download_csv';
import AddForm from './add_panel';
import UpdateForm from './update_panel';
import DropDown from '../shared/dropdown';
import { messages, placeHolders, labels, tablePageSize, buttonNames } from './settings';

import './exam_request.css';
import SearchPager from 'shared_components/search_pager';

const { Text } = Typography;
const { Search } = Input;

const TARGET_WIDTH = 1366;
const TARGET_HEIGHT = 768;
const COVERAGE_THRESHOLD = 0.8;

class LabExamRequest extends React.Component {
	state = {
		selectedSectionId: null,
		selectedSpecimenId: null,
		selectedSectionName: null,
		selectedSpecimenName: null,
		isInitializing: true,
		isLoading: false,
		pageSize: tablePageSize,
		isShowAddForm: false,
		isShowUpdateForm: false,
		examRequestsRef: [],
		examRequests: [],
		ddSections: [],
		ddSpecimens: [],
		ddRecords: [],
		examItems: [],
		selectedExamRequest: {},
		currentPage: 1,
		searchTerm: '',
	};

	async componentDidMount() {
		setTimeout(async () => {
			const showActiveSectionsOnly = 1;
			const showActiveSpecimenOnly = 1;
			const sections = await fetchSection(showActiveSectionsOnly);
			const specimens = await fetchSpecimens(showActiveSpecimenOnly);
			const ddSections = sections.slice().map(section => ({
				label: section.sectionName,
				value: section.sectionID,
			}));
			// .sort((a, b) => a.sectionID.localeCompare(b.sectionID))
			// console.log('sections =>', sections.filter(sec => sec.isActive === 1));

			// ddSections = ddSections.filter(sec => sec.isActive === 1);
			console.log('specimens =>', specimens);

			const ddSpecimens = specimens.map(specimen => ({
				label: specimen.specimenName,
				value: specimen.specimenID,
			}));
			// .filter(specimen => specimen.isActive === 1)
			// .sort((a, b) => a.specimenID.localeCompare(b.specimenID));

			this.setState({
				ddSections,
				ddSpecimens,
				selectedSpecimenId: specimens[0].specimenID ? specimens[0].specimenID : null,
				selectedSpecimenName: specimens[0].specimenName ? specimens[0].specimenName : null,
				isInitializing: false,
			});

			// this.onViewportCheck(); // initial check
			// window.addEventListener('resize', this.onViewportCheck);
			// if (window.visualViewport) window.visualViewport.addEventListener('resize', this.onViewportCheck);
		}, 500);
	}

	// componentWillUnmount() {
	// 	window.removeEventListener('resize', this.onViewportCheck);
	// 	if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.onViewportCheck);
	// }

	// // --- viewport helpers ---
	// getViewport = () => {
	// 	const vw = (window.visualViewport && window.visualViewport.width) || window.innerWidth;
	// 	const vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
	// 	const dpr = window.devicePixelRatio || 1;
	// 	return { vw, vh, dpr };
	// };

	// getCoverage = (targetW = TARGET_WIDTH, targetH = TARGET_HEIGHT) => {
	// 	const { vw, vh } = this.getViewport();
	// 	const widthCoverage = vw / targetW;
	// 	const heightCoverage = vh / targetH;
	// 	const areaCoverage = (vw * vh) / (targetW * targetH);
	// 	return { widthCoverage, heightCoverage, areaCoverage };
	// };

	// isAtOrAboveThreshold = (targetW = TARGET_WIDTH, targetH = TARGET_HEIGHT, threshold = COVERAGE_THRESHOLD, mode = 'area') => {
	// 	const cov = this.getCoverage(targetW, targetH);
	// 	switch (mode) {
	// 		case 'width':
	// 			return cov.widthCoverage >= threshold;
	// 		case 'height':
	// 			return cov.heightCoverage >= threshold;
	// 		case 'both':
	// 			return cov.widthCoverage >= threshold && cov.heightCoverage >= threshold;
	// 		default:
	// 			return cov.areaCoverage >= threshold;
	// 	}
	// };

	// // handler called on resize/initial mount
	// onViewportCheck = () => {
	// 	const ok = this.isAtOrAboveThreshold();
	// 	// update state only when changed
	// 	if (ok !== this.state.isAtOrAbove80) {
	// 		this.setState({ isAtOrAbove80: ok });
	// 	}
	// 	// debug/log
	// 	const cov = this.getCoverage();
	// 	// console.log('viewport coverage =>', cov, '>=80%?', ok);
	// };
	// // --- end viewport helpers ---

	onSuccessCreateExamReq = () => {
		showMessage('M0002');

		this.setState({ isLoading: true, isShowAddForm: false }, async () => {
			const { selectedSpecimenId: specimenId, selectedSectionId: sectionId } = this.state;
			const examRequests = await fetchExamRequests(sectionId, specimenId);
			const sortedExamRequests = this.sortByExamItemSort(examRequests || []);

			this.setState({
				examRequests: sortedExamRequests || [],
				examRequestsRef: sortedExamRequests || [],
				isLoading: false,
			});
		});
	};

	onSuccessUpdateExamReq = () => {
		showMessage('M0003');

		this.setState({ isLoading: true, isShowUpdateForm: false }, async () => {
			const { selectedSpecimenId: specimenId, selectedSectionId: sectionId } = this.state;
			const examRequests = await fetchExamRequests(sectionId, specimenId);
			const sortedExamRequests = this.sortByExamItemSort(examRequests || []);

			this.setState({
				examRequests: sortedExamRequests || [],
				examRequestsRef: sortedExamRequests || [],
				isLoading: false,
			});
		});
	};

	onChangeSection = async (sectionId, option) => {
		this.setState({ isLoading: true, selectedSectionId: sectionId }, async () => {
			const { selectedSpecimenId: specimenId } = this.state;
			const examRequests = await fetchExamRequests(sectionId, specimenId, '', false);
			const sorted = this.sortByExamItemSort(examRequests || []);
			// const examRequests = [];

			//this is for jrreports
			const sections = await fetchSection(); // fetch section
			const selectedSection = sections.find(section => section.sectionID === sectionId); // find section id on selected section
			const selectedSectionName = selectedSection ? selectedSection.sectionName : null; // find section name on seleced section

			// temporarily disabled to await for the awaited API of the jrreports.

			const jrReports = await fetchJrReports(selectedSectionName); // fetch JrReports
			const records = jrReports.length === 0 ? [] : jrReports[0].records; // conditional if records is empthy return empthy arry if have records return records
			const ddRecords = records.map(record => ({
				label: record.reportname,
				value: record.reportname,
			}));

			this.setState(
				{
					ddRecords: ddRecords,
					examRequests: sorted || [],
					examRequestsRef: sorted || [],
					selectedSectionId: sectionId,
					selectedSectionName: option.props.children,
					isLoading: true,
				},
				async () => {
					const examItems = await fetchExamList(sectionId, specimenId, true);
					this.setState({ examItems: examItems || [], isLoading: false });
				},
			);
		});
	};

	onChangeSpecimen = (specimenId, option) => {
		this.setState({ isLoading: true, selectedSpecimenId: specimenId }, async () => {
			const { selectedSectionId: sectionId } = this.state;
			const examRequests = await fetchExamRequests(sectionId, specimenId, '', false);
			const sorted = this.sortByExamItemSort(examRequests || []);
			const examItems = await fetchExamList(sectionId, specimenId, true);

			this.setState({
				examRequests: sorted,
				examRequestsRef: sorted,
				selectedSpecimenId: specimenId,
				selectedSpecimenName: option.props.children,
				isLoading: false,
				examItems: examItems || [],
			});
		});
	};

	onSearch = async value => {
		const { examRequestsRef, selectedSectionId, selectedSpecimenId } = this.state;
		const searchedVal = value.toLowerCase();
		this.setState({ searchTerm: searchedVal });
		this.onPaginationChange(1);

		const examRequests = await fetchExamRequests(
			selectedSectionId,
			selectedSpecimenId,
			searchedVal,
		);
		// console.log('examRequests on search =>', examRequests);

		const filtered = examRequests.filter(item => {
			const { examRequestName, examRequestCode, examRequestIntegrationCode } = item;

			return (
				this.containsString(examRequestName, searchedVal) ||
				this.containsString(examRequestCode, searchedVal) ||
				this.containsString(examRequestIntegrationCode, searchedVal)
			);
		});

		// Show "No result found" message if no results
		// if (filtered.length === 0 && value.trim() !== '') {
		// 	showMessage('M0001');
		// }

		const sortedFiltered = this.sortByExamItemSort(filtered || []);

		this.setState({ examRequests: sortedFiltered });
	};

	onChangeSearch = event => {
		const { examRequestsRef } = this.state;
		const { value } = event.target;

		if (value === '') {
			this.setState({ examRequests: examRequestsRef, searchTerm: '' });
		} else {
			this.setState({ searchTerm: value });
		}
	};

	onDblClickTableRow = selectedExamRequest => {
		this.setState({ selectedExamRequest, isShowUpdateForm: true });
	};

	onClickAdd = () => {
		this.setState({ isShowAddForm: true });
	};

	onChangePager = pageSize => {
		this.setState({ pageSize });
	};

	closeForm = () => {
		this.setState({
			isShowAddForm: false,
			isShowUpdateForm: false,
			selectedExamRequest: {},
		});
	};

	// Private Function
	containsString = (searchFrom, searchedVal) => {
		// console.log('searchFrom =>', searchFrom);
		// console.log('searchedVal =>', searchedVal);
		if ([null, '', undefined].includes(searchFrom)) return false;

		return searchFrom
			.toString()
			.toLowerCase()
			.includes(searchedVal);
	};

	onPaginationChange = pagination => {
		this.setState({ currentPage: pagination });
	};

	onDragAndDropRow = updatedData => {
		console.log('updatedData =>', updatedData);
		this.setState({ examRequests: updatedData });
	};

	sortByExamItemSort = examRequests => {
		return examRequests.sort((a, b) => {
			return (a.examRequestSort || 0) - (b.examRequestSort || 0);
		});
	};

	applySort = async () => {
		const { examRequests } = this.state;

		const reqIds = examRequests.slice().map(req => {
			return { examRequestID: req.examRequestID };
		});
		// console.log('null');
		console.log('reqIds =>', reqIds);
		// console.log('reqIds stringify =>', JSON.stringify(reqIds));

		const updatedExamRequestSort = await updateExamRequestSort(JSON.stringify(reqIds));
		// console.log('updatedExamRequestSort =>', updatedExamRequestSort);

		if (updatedExamRequestSort) {
			showMessage('M0006');

			this.setState({ isLoading: true }, async () => {
				const { selectedSpecimenId: specimenId, selectedSectionId: sectionId } = this.state;
				const examRequests = await fetchExamRequests(sectionId, specimenId);
				const sortedExamRequests = this.sortByExamItemSort(examRequests);

				this.setState({
					examRequests: sortedExamRequests || [],
					examRequestsRef: sortedExamRequests || [],
					isLoading: false,
				});
			});
		}
	};

	render() {
		const {
			pageSize,
			examRequests,
			ddSpecimens,
			ddSections,
			ddRecords,
			isShowAddForm,
			isShowUpdateForm,
			isLoading,
			isInitializing,
			selectedSectionId,
			selectedSpecimenId,
			selectedExamRequest,
			selectedSectionName,
			selectedSpecimenName,
			currentPage,
			examRequestsRef,
		} = this.state;

		return (
			<div>
				<Row justify="center" style={{ marginTop: 30 }}>
					<Col>
						<PageTitle pageTitle="EXAM REQUEST" />
					</Col>
				</Row>

				<Row
					style={{
						display: 'flex',
						gap: '10px',
						justifyContent: 'space-between',
						alignItems: 'end',
						marginTop: 30,
					}}
				>
					<Col style={{ display: 'flex', textAlign: 'left', gap: '10px' }}>
						<div>
							<p style={{ margin: 0 }}>SECTION</p>
							<DropDown
								placeholder={placeHolders.sectionDropdown}
								content={ddSections}
								onChange={this.onChangeSection}
								value={selectedSectionId}
								loading={isInitializing}
							/>
						</div>
						<div>
							<p style={{ margin: 0 }}>SPECIMEN</p>
							<DropDown
								size="small"
								placeholder={placeHolders.specimenDropdown}
								content={ddSpecimens}
								disabled={selectedSectionId == null}
								onChange={this.onChangeSpecimen}
								loading={isInitializing}
								value={selectedSpecimenId}
							/>
						</div>
						<div>
							<p style={{ margin: 0 }}>SEARCH</p>
							<Search
								allowClear
								onSearch={value => this.onSearch(value)}
								onChange={this.onChangeSearch}
								style={{ width: 200 }}
								disabled={selectedSectionId == null}
								className="exam-request-search-input"
							/>
						</div>
					</Col>
					<Col style={{ display: 'flex', gap: '10px', justifyContent: 'end' }}>
						<Button onClick={this.applySort} shape="round" type="primary">
							APPLY SORTING
						</Button>
						<DownloadCSV
							confirmRequired={true}
							isLookupTable={false}
							filename="exam_request"
							confirmDetails={{
								title: 'EXAM REQUEST',
								section: selectedSectionName || 'All',
								specimen: selectedSpecimenName || 'All',
								count: (examRequestsRef || []).length,
							}}
							data={examRequestsRef}
							disabled={selectedSectionId === null || (examRequestsRef || []).length === 0}
							columns={[
								{ title: 'ID', dataIndex: 'examRequestID' },
								{ title: 'EXAM REQUEST NAME', dataIndex: 'examRequestName' },
								{ title: 'EXAM REQUEST CODE', dataIndex: 'examRequestCode' },
								{ title: 'Loinc', dataIndex: 'examRequestLoinc' },
								{ title: 'INTEGRATION CODE', dataIndex: 'examRequestIntegrationCode' },
								{
									title: 'STATUS',
									dataIndex: 'examRequestIsActive',
									render: active => (active === 0 ? 'INACTIVE' : 'ACTIVE'),
								},
							]}
						/>
						<UserAccessContext.Consumer>
							{value =>
								value.userAccess.settings.create && (
									<Button
										shape="round"
										type="primary"
										onClick={this.onClickAdd}
										disabled={selectedSectionId === null}
									>
										<PlusOutlined />
										{buttonNames.addExam}
									</Button>
								)
							}
						</UserAccessContext.Consumer>
						<div style={{ marginTop: 5 }}></div>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<SearchPager
							pageSize={pageSize}
							pageTotal={examRequests.length}
							handleChangeSize={this.onChangePager}
							currentPage={currentPage}
						/>
					</Col>
				</Row>
				<ExamTable
					data={examRequests}
					pageSize={pageSize}
					loading={isLoading}
					onRowDblClick={this.onDblClickTableRow}
					onPaginationChange={this.onPaginationChange}
					onDragAndDropRow={this.onDragAndDropRow}
				/>
				<AddForm
					visible={isShowAddForm}
					closeForm={this.closeForm}
					onSuccess={this.onSuccessCreateExamReq}
					sectionId={selectedSectionId}
					specimenId={selectedSpecimenId}
					selectedSectionName={selectedSectionName}
					selectedSpecimenName={selectedSpecimenName}
					ddRecords={ddRecords}
					nextSort={examRequests.length + 1}
				/>
				<UpdateForm
					examRequest={selectedExamRequest}
					visible={isShowUpdateForm}
					closeForm={this.closeForm}
					onSuccess={this.onSuccessUpdateExamReq}
					sectionId={selectedSectionId}
					specimenId={selectedSpecimenId}
					examRequestId={selectedExamRequest.examRequestID}
					selectedSectionName={selectedSectionName}
					selectedSpecimenName={selectedSpecimenName}
					ddRecords={ddRecords}
				/>
			</div>
		);
	}
}

export default LabExamRequest;
